export default __webpack_public_path__ + "static/media/cover.d81d7c7c.png";